import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { EquipmentForm } from '../form';

export const CreateUpdateEquipmentDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.CreateUpdateEquipmentDialog);

  if (!data) throw new Error('Data is required');

  return (
    <Dialog fullWidth maxWidth="lg" open={isOpen} onClose={handleClose}>
      <DialogTitle>{data.equipmentId ? 'Edit' : 'Create new'} equipment</DialogTitle>

      <DialogContent dividers>
        <EquipmentForm {...data} />
      </DialogContent>
    </Dialog>
  );
};
